import { render, staticRenderFns } from "./ConfigurazioniMagazzinoArticoliUmModalEditComponent.vue?vue&type=template&id=1d71c351"
import script from "./ConfigurazioniMagazzinoArticoliUmModalEditComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniMagazzinoArticoliUmModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports